import { render } from "./UpdateNotification.vue?vue&type=template&id=77902ef8&ts=true"
import script from "./UpdateNotification.vue?vue&type=script&lang=ts"
export * from "./UpdateNotification.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UpdateNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77902ef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77902ef8', __exports__)) {
    api.reload('77902ef8', __exports__)
  }
  
  module.hot.accept("./UpdateNotification.vue?vue&type=template&id=77902ef8&ts=true", () => {
    api.rerender('77902ef8', render)
  })

}


export default __exports__